import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, BarChart3, Mail, LogOut, Shield } from 'lucide-react';
import useAuthStore from '../../context/authStore';
import toast from 'react-hot-toast';

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/admin/members', icon: Users, label: 'Members' },
  { to: '/admin/reports', icon: BarChart3, label: 'Reports' },
  { to: '/admin/email-config', icon: Mail, label: 'Email Settings' },
];

export default function AdminLayout() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success('Logged out');
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)' }}>
      <aside style={{
        width: 260, background: 'var(--primary-dark)',
        display: 'flex', flexDirection: 'column',
        position: 'fixed', top: 0, bottom: 0, left: 0, zIndex: 100,
      }}>
        {/* Bug 3 & 7: BPS Branding with Logo */}
        <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 44, height: 44, borderRadius: '50%',
              background: 'white', overflow: 'hidden',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0, border: '2px solid rgba(255,255,255,0.3)'
            }}>
              <img
                src="/logo.png"
                alt="BPS"
                style={{ width: '85%', height: '85%', objectFit: 'contain' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = '<span style="color:#1a3a5c;font-weight:700;font-size:12px;">BPS</span>';
                }}
              />
            </div>
            <div>
              <h1 style={{ color: 'white', fontSize: 13, fontFamily: "'Playfair Display', serif", lineHeight: 1.3 }}>
                Bombay Psychiatric Society
              </h1>
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 2 }}>
                <Shield size={11} style={{ color: 'var(--accent)' }} />
                <span style={{ color: 'var(--accent-light)', fontSize: 11 }}>Admin Panel</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: '14px 24px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginBottom: 2 }}>LOGGED IN AS</div>
          <div style={{ color: 'white', fontSize: 14, fontWeight: 600 }}>
            {user?.firstName} {user?.lastName}
          </div>
        </div>

        <nav style={{ flex: 1, padding: '12px 0' }}>
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '11px 24px',
                color: isActive ? 'white' : 'rgba(255,255,255,0.6)',
                background: isActive ? 'rgba(255,255,255,0.1)' : 'transparent',
                textDecoration: 'none', fontSize: 14,
                fontWeight: isActive ? 600 : 400,
                borderLeft: isActive ? '3px solid var(--accent)' : '3px solid transparent',
                transition: 'all 0.15s',
              })}
            >
              <Icon size={17} /> {label}
            </NavLink>
          ))}
        </nav>

        <div style={{ padding: '16px 24px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <button onClick={handleLogout} style={{
            display: 'flex', alignItems: 'center', gap: 10,
            color: 'rgba(255,255,255,0.6)', background: 'none',
            border: 'none', cursor: 'pointer', fontSize: 14, width: '100%', padding: '8px 0'
          }}>
            <LogOut size={16} /> Logout
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, marginLeft: 260 }}>
        <div style={{
          background: 'white', padding: '0 28px', height: 60,
          display: 'flex', alignItems: 'center',
          borderBottom: '1px solid var(--border)',
          position: 'sticky', top: 0, zIndex: 50
        }}>
          <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>
            Bombay Psychiatric Society — <strong style={{ color: 'var(--primary)' }}>Administration</strong>
          </span>
        </div>
        <div style={{ padding: '28px 32px' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
